import { Chip, Box } from "@mui/material"

import useAppStore from "store/app"
import { useEffect } from "react"

const Chips = () => {
  const getSymptoms = useAppStore((state) => state.getSymptoms)
  const symptoms = useAppStore((state) => state.anamnesis.symptoms)
  const deleteSymptom = useAppStore((state) => state.deleteSymptom)

  useEffect(() => {
    getSymptoms()
  }, [])

  const handleDelete = (id) => {
    deleteSymptom(id)
  }

  return (
    <Box>
      {symptoms.map((symptom) => (
        <Chip
          key={symptom?.id}
          label={symptom?.name}
          variant="outlined"
          onDelete={() => handleDelete(symptom?.id)}
          sx={{
            my: 1,
            mx: 0.5,
            p: 1,
            maxWidth: 300,
            backgroundColor: "#E0EBFF",
            border: "none",
          }}
        />
      ))}
    </Box>
  )
}

export default Chips
